import { IACHDisbursementFormData } from '../../../../../../types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { defaultMemo } from '../defaultMemo';
import { IOrderDetailsData } from '../../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const convertACHToWireInitialValue = (
  ach: IACHDisbursementFormData,
  order: IOrderDetailsData,
  isSpruceWithZillowEnabled: boolean,
  isZillowClosing: boolean
) => {
  return {
    account_number: ach.account?.accountNumber,
    ach_account_id: ach.account?.id || '',
    amount: ach.amountCents ? ach.amountCents / 100 : undefined,
    beneficiary_name: ach.account?.name,
    category: undefined,
    escrow_file_id: order.transaction.escrow_file_id,
    memo: defaultMemo(order, isSpruceWithZillowEnabled, isZillowClosing),
    routing_number: '',
    state_abbreviation: order.property.state ?? '',
    achAccountId: ach.account?.id,
    ach_push_id: ach.id,
  };
};
